import { initializeApp } from "firebase/app";
import { getFirestore, initializeFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCCtUEn42asGDqbj5AVUFE8P3Zv0uucPVQ",
  authDomain: "assubuildtechwebsite.firebaseapp.com",
  projectId: "assubuildtechwebsite",
  storageBucket: "assubuildtechwebsite.firebasestorage.app",
  messagingSenderId: "648212060306",
  appId: "1:648212060306:web:06eb1d0f57770627462e4b",
  measurementId: "G-HLN3MDR5N3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Cloud Firestore and Auth
// Force long-polling to prevent Lighthouse WebStream severing (ERR_TIMED_OUT console errors)
export const db = initializeFirestore(app, { experimentalForceLongPolling: true });
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
